/**
 * 实例数据类型
 */
export enum InstanceDataType {
    /** 框架 */
    Framework = 'framework',
    /** 状态 */
    State = 'state',
    /** 行为 */
    Behaviors = 'behaviors',
    /** 核心 */
    Core = 'core',
    /** 舞台 */
    Stage = 'stage',
    /** 操作 */
    Operate = 'operate',
    /** 历史 */
    History = 'history',
    /** 触摸数据 */
    TouchData = 'touchData',
    /** 触摸监听列表 */
    TouchListenerList = 'touchListenerList',
    /** 激活信息 */
    ActiveInfo = 'activeInfo',
    /** 选中图层信息 */
    SelectedInfo = 'selectedInfo',
}

/** 多实例数据管理 */
export class InstanceData {
    private static instancesData: Record<
        string,
        {
            /** 框架 */
            [InstanceDataType.Framework]: unknown;
            /** 状态 */
            [InstanceDataType.State]: unknown;
            /** 行为 */
            [InstanceDataType.Behaviors]: unknown;
            /** 核心 */
            [InstanceDataType.Core]: unknown;
            /** 舞台 */
            [InstanceDataType.Stage]: unknown;
            /** 操作 */
            [InstanceDataType.Operate]: unknown;
            /** 历史 */
            [InstanceDataType.History]: unknown;
            /** 触摸数据 */
            [InstanceDataType.TouchData]: unknown;
            /** 触摸监听列表 */
            [InstanceDataType.TouchListenerList]: unknown;
            /** 激活信息 */
            [InstanceDataType.ActiveInfo]: unknown;
            /** 选中图层信息 */
            [InstanceDataType.SelectedInfo]: unknown;
            /** 销毁列表 */
            destroyList: unknown[];
        }
    > = {};

    /** 销毁实例事件 */
    static onDestroy(identity: string, listener: (identity: string) => void) {
        this.instancesData[identity] = this.instancesData[identity] || {};
        this.instancesData[identity].destroyList = this.instancesData[identity].destroyList || [];
        this.instancesData[identity].destroyList.push(listener);
    }

    /** 获取实例数据 */
    static getData<T>(identity: string, type: InstanceDataType): T {
        return this.instancesData[identity]?.[type] as T;
    }

    /** 设置实例数据 */
    static setData(identity: string, type: InstanceDataType, data: unknown) {
        this.instancesData[identity] = this.instancesData[identity] || {};
        this.instancesData[identity][type] = data;
    }

    /** 设置实例数据项 */
    static setRecordItem(identity: string, type: InstanceDataType, key: string, value: unknown) {
        this.instancesData[identity] = this.instancesData[identity] || {};
        this.instancesData[identity][type] = this.instancesData[identity][type] || {};
        (this.instancesData[identity][type] as Record<string, unknown>)[key] = value;
    }

    /** 获取实例数据项 */
    static getRecordItem(identity: string, type: InstanceDataType, key: string) {
        return this.instancesData[identity]?.[type]?.[key];
    }

    /** 删除实例 */
    static delInstance(identity: string) {
        this.instancesData[identity]?.destroyList?.forEach((listener) => (listener as (i: string) => void)(identity));
        delete this.instancesData[identity];
    }
}
